import gql from 'graphql-tag';
import ReportFragment from '../reports/reportFragment';

const favoritePageQuery = gql`
  query favoritePage($input: FavoritePagesQueryInput!, $reportInput: FavoriteQueryReportInput!) {
    favoritePages(input: $input) {
      total
      pages {
        favorites {
          id
          report(input: $reportInput) {
            settings {
              id
              favoriteDesc
              period {
                type
                range {
                  start
                  end
                }
              }
              workplaces {
                type
              }
              interruptingDisfunctions {
                type
              }
              notInterruptingDisfunctions {
                type
              }
              products {
                type
              }
              productStates {
                type
              }
              shifts {
                type
              }
            }
            ...ReportFragment
          }
        }
      }
      hasNextPage
    }
  }
  ${ReportFragment}
`;

export default favoritePageQuery;
